import { displayName } from "../emulator/saves";
import { api } from "@common/api";
import { formatDuration } from "@jkast90/kast-common/format";
import type { GamePlay, PlayReport } from "../types/api";

// Time played per game, kept by play-api in DynamoDB. Games are keyed by their
// display name lowercased (as covers are), so copies under other file names
// add up to one total.

export type { GamePlay } from "../types/api";

export const playKey = (name: string) => displayName(name).toLowerCase();

export async function myPlaytime(): Promise<GamePlay[]> {
  return api.get("/playtime");
}

/** Adds active seconds to a game's total. `keepalive` lets it finish as the page closes. */
export async function reportPlay(name: string, system: string, seconds: number, keepalive = false) {
  await api.post("/playtime", {
    body: { game: playKey(name), name, system, seconds } satisfies PlayReport,
    keepalive,
  });
}

/** "3h 12m", "45m", "under a minute": formatDuration, from seconds, to the minute. */
export const formatPlayed = (seconds: number) =>
  formatDuration(seconds * 1000, { minUnit: "m", zero: "under a minute" });
